<template>
  <WdsHeading class="tw-mb-7 tw-mt-5">{{ $t('Approvals') }}</WdsHeading>
  <WdsTabs data-test="approvals-tabs">
    <WdsTab :title="$t('Workflows')" data-test="workflows" tab-key="workflows">
      <WorkflowSettingsPage />
    </WdsTab>
    <WdsTab :title="$t('Groups')" data-test="groups" tab-key="groups">
      <GroupsSettingsPage />
    </WdsTab>
  </WdsTabs>
</template>

<script lang="ts" setup>
import { WdsTabs, WdsTab, WdsHeading } from '@worksome/wds-components'
import GroupsSettingsPage from '@/components/Workflows/Pages/Groups/GroupsSettingsPage.vue'
import WorkflowSettingsPage from '@/components/Workflows/Pages/Workflow/WorkflowSettingsPage.vue'
import { $t } from '@/app-bootstrapping/SetUpInternationalization'
</script>
